// Talk to Me turn-taking rules (plain JS so they can be unit-tested).

// How long a pause ends the user's turn. A complete-sounding phrase ends
// quickly (like a person replying), but a phrase that trails off on a
// connector or a comma gets more time to continue the thought.
export const TURN_PAUSE_MS = 800;
export const TURN_PAUSE_TRAILING_MS = 1500;
// Recorder path (no live transcript): one pause length for every turn.
export const RECORDER_PAUSE_MS = 1100;

const TRAILING = /(?:,|\.\.\.|…|\b(?:and|but|so|or|because|cause|the|a|an|to|of|with|for|in|on|at|um+|uh+|er|like|then|if|that|which|who|my|your|is|was|i|we|it's|i'm))\s*$/i;

export function voiceTurnPauseMs(text) {
  const t = String(text || "").trim();
  if (!t) return TURN_PAUSE_TRAILING_MS;
  return TRAILING.test(t) ? TURN_PAUSE_TRAILING_MS : TURN_PAUSE_MS;
}

// First words sooner: before any sentence has finished streaming, cut the
// reply at its first clause break (comma, semicolon, colon, dash) once there
// are enough words to sound natural. Returns the cut index or -1.
export function firstClauseCut(text, minChars = 24) {
  const s = String(text || "");
  const re = /[,;:—–]\s/g;
  let m;
  while ((m = re.exec(s)) !== null) {
    if (m.index >= minChars) return m.index + m[0].length;
  }
  return -1;
}
